import { defineEvent } from "@amtana/module";
import { z } from "zod";

// Snooze, quiet hours, bursts and digests release as a wake of a notification-owned process
// manager in the Go worker, not the 30-second sweep (ADR-022 point 9, revision 4, epic 26,
// S26.16). Every time something is held for a person, or a wake fires and something is still
// held, `NotificationEmailService` recomputes the one instant its next release is due and
// appends this fact, keyed by `userId`. `services/worker/internal/pipelines/notification_hold.go`
// carries no business logic (D462's own precedent, D519): its decide step only remembers the
// latest `wakeAt` the api computed (the api always recomputes the full picture before it
// appends, so the newest fact already reflects everything currently held), and its wake fires
// one "release" intent, the api's own `releaseHold` door deciding everything (snooze, quiet
// hours, bursts, digests) and re-appending this fact itself when something remains.

export const NOTIFICATION_HOLD = "notification-hold";

export const emailHeld = defineEvent(
  NOTIFICATION_HOLD,
  "email_held",
  z.object({ userId: z.string().min(1), wakeAt: z.string().min(1) }),
);

export const notificationHoldEvents = [emailHeld] as const;
